import React from 'react';

const CurrentContext = React.createContext({ current: 'home', subCurrent: '' });

export default CurrentContext;
